module.exports = __webpack_public_path__ + "static/media/MV.9c0ceed1.svg";